import React from 'react';
import { motion } from 'framer-motion';
import { PhoneIcon, CheckCircle2Icon, ClockIcon, ShieldCheckIcon, ChevronDownIcon } from 'lucide-react';
export function Hero() {
  return <section id="home" className="relative z-0 h-screen min-h-[800px] flex items-center justify-center overflow-hidden" data-id="element-131">
      {/* Background Image with Slow Zoom */}
      <motion.div className="absolute inset-0 z-0" initial={{
      scale: 1
    }} animate={{
      scale: 1.05
    }} transition={{
      duration: 20,
      repeat: Infinity,
      repeatType: 'reverse',
      ease: 'linear'
    }} data-id="element-132">
        <img src="https://cdn.magicpatterns.com/uploads/ngBkr9wbTzH6wtXkfUvPJx/heylloyd-image-1775569938042.png" alt="Beautiful landscaped garden" className="w-full h-full object-cover" data-id="element-133" />
        <div className="absolute inset-0 bg-forest-dark/60 mix-blend-multiply" data-id="element-134" />
        <div className="absolute inset-0 bg-gradient-to-b from-forest-dark/80 via-transparent to-forest-dark/90" data-id="element-135" />
      </motion.div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full pt-20" data-id="element-136">
        <div className="max-w-4xl mx-auto text-center" data-id="element-137">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} data-id="element-138">
            <h1 className="text-5xl md:text-7xl font-bold text-white leading-tight mb-6 font-serif drop-shadow-lg" data-id="element-139">
              Manny's The Green Mountain <br className="hidden md:block" data-id="element-140" />
              <span className="text-gold italic" data-id="element-141">Landscaping</span>
            </h1>
            <p className="text-xl md:text-2xl text-gray-200 mb-12 leading-relaxed font-light max-w-3xl mx-auto drop-shadow-md" data-id="element-142">
              Premium Landscaping, Maintenance, and Hardscaping services in
              Washington State. Professional results, whether you need an hourly
              wage service or a fixed contract.
            </p>
          </motion.div>

          {/* Highlights - Glassmorphism */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.3,
          ease: 'easeOut'
        }} className="flex flex-col sm:flex-row justify-center gap-4 mb-12" data-id="element-143">
            {[{
            icon: CheckCircle2Icon,
            text: 'Free Estimates'
          }, {
            icon: ClockIcon,
            text: 'Hourly or Contract Based'
          }, {
            icon: ShieldCheckIcon,
            text: 'Reliable & Professional'
          }].map((item, index) => <div key={index} className="flex items-center justify-center gap-3 bg-white/10 backdrop-blur-md px-6 py-3 rounded-full border border-white/20 text-white shadow-xl hover:bg-white/20 transition-colors" data-id="element-144">
                <item.icon className="w-5 h-5 text-gold" data-id="element-145" />
                <span className="font-medium tracking-wide" data-id="element-146">{item.text}</span>
              </div>)}
          </motion.div>

          {/* CTAs */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.5,
          ease: 'easeOut'
        }} className="flex flex-col sm:flex-row justify-center gap-6" data-id="element-147">
            <a href="#contact" className="group relative overflow-hidden bg-gold text-forest-dark px-8 py-4 rounded-lg font-bold text-lg transition-all shadow-xl hover:shadow-gold/20 flex items-center justify-center gap-2" data-id="element-148">
              <span className="relative z-10" data-id="element-149">Get Your Free Estimate</span>
              <div className="absolute inset-0 h-full w-full bg-white/20 transform -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-500 ease-out" data-id="element-150"></div>
            </a>
            <a href="tel:360-623-4531" className="bg-forest-dark/40 backdrop-blur-sm hover:bg-forest-dark/60 text-white border border-white/30 px-8 py-4 rounded-lg font-bold text-lg transition-all shadow-xl flex items-center justify-center gap-3" data-id="element-151">
              <div className="bg-white/10 p-2 rounded-full" data-id="element-152">
                <PhoneIcon className="w-5 h-5 text-gold" data-id="element-153" />
              </div>
              Call 360-623-4531
            </a>
          </motion.div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.5,
      duration: 1
    }} className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center text-white/70" data-id="element-154">
        <span className="text-sm font-medium tracking-widest uppercase mb-2" data-id="element-155">
          Scroll
        </span>
        <motion.div animate={{
        y: [0, 8, 0]
      }} transition={{
        duration: 1.5,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-156">
          <ChevronDownIcon className="w-6 h-6" data-id="element-157" />
        </motion.div>
      </motion.div>
    </section>;
}